document.querySelectorAll(".input-percent").forEach(input => {
    const blockId = input.dataset.blockId;
    const progressBar = document.getElementById("progressBar-" + blockId);
    let currentProgress = 0;
    let animationFrame;
    let lastTarget = 0;
    input.addEventListener("input", () => {
      const target = parseInt(input.value);
      const maxProgress = 1000;
      if (isNaN(target) || target < 0 || target > maxProgress) return;
      if (target === lastTarget) return;
      lastTarget = target;
      cancelAnimationFrame(animationFrame);
      const targetWidth = (target / maxProgress) * 100;
      function animate() {
        if (currentProgress < targetWidth) {
          currentProgress += 0.5;
        } else if (currentProgress > targetWidth) {
          currentProgress -= 0.5;
        }
        progressBar.style.width = currentProgress + "%";
        progressBar.textContent = Math.round(currentProgress * (maxProgress / 100)) + "%";

        if (Math.abs(currentProgress - targetWidth) > 0.1) {
          animationFrame = requestAnimationFrame(animate);
        }
      }
      animate();
    });
  });

  ////////


  document.addEventListener("DOMContentLoaded", function () {
    const tabLinks = document.querySelectorAll(".tab-link");
    const tabContents = document.querySelectorAll(".tab-content");

    tabLinks.forEach(link => {
      link.addEventListener("click", () => {
   
        tabContents.forEach(content => content.style.display = "none");
    
        tabLinks.forEach(link => link.classList.remove("active"));

        const targetId = link.getAttribute("data-tab");
        document.getElementById(targetId).style.display = "block";

        link.classList.add("active");
      });
    });

    if (tabLinks.length > 0) {
      tabLinks[0].click();
    }
  });

